import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";


// components
import BackDrop from "../components/backdrop";

// states_g
import { setgtMessage } from "../redux/gtmsgSlice";
import { gtNeutral } from "../redux/gtstatusSlice";

// hooks
import { useAppuserout } from "../hooks/general/useAppuserout";
import { useAiscore } from "../hooks/general/useAiscore";

// utilities
import { icons } from "../utilities/icn";
import { images } from "../utilities/img";
import { ReactComponent as EvalysLogo } from './../media/img/evalys_logo_svg.svg';


const Home = () => {  

    const navigate = useNavigate()
    const { checkAppUser } = useAppuserout()
    const { handleAiscore } = useAiscore()
    
    const user = useSelector((state) => state.user.value)
    
    const dispatch = useDispatch()
    
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [demodep, setdemodep] = useState(null)

    useEffect(() => {
        // checkAppUser()
    }, [])

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const setAlltoNull = () => {
    }



    return ( 

        <div className="">

            
            <section className={`home ${windowWidth > 800 ? 'flex justify-center align-center' : ''}`} id="home">
                <div className="bg-video-cont">
                    <video src={images.general.eva_home_bg_2} autoPlay muted loop />
                </div>

                <div className="home-contents overflow-y-hidden">
                    <h2 className={`text-align-center ${windowWidth < 800 ? 'mgb-10' : 'mgb-20'} overflow-y-hidden lg_bold`} data-aos="fade-up" data-aos-duration="1500">
                        The Privacy Layer<br />
                        for Solana Launchpads
                    </h2>
                    <h3 className="text-align-center overflow-y-hidden lg_regular" data-aos="fade-up" data-aos-duration="2000">
                        Evalys is a specialized, launchpad native privacy infrastructure engineered to protect creators, <br />
                        early traders, and high-velocity memecoin ecosystems from the dangers of full chain transparency.
                    </h3>
                    {/* <div className="flex justify-center overflow-y-hidden">
                        <Link to="/eva" className="flex row gap-10 overflow-y-hidden" data-aos="fade-up" data-aos-duration="2500">
                            <p className="inter">Ask Eva</p>
                            <img src={icons.general.angle_right} alt="" />
                        </Link>
                    </div> */}
                    <div className="bottom-features oveflow-y-hidden">
                        <div className={`bottom-features-inner grid ${windowWidth < 900 ? 'gap-10' : 'gap-35'} ${windowWidth < 800 ? 'grid-column-1' : 'grid-column-4'} overflow-y-hidden`}>
                            
                            <div className="feature-box position-relative" data-aos="fade-right">
                                <div className="ft-effect top-right"></div>
                                <div className="ft-effect bottom-left"></div>
                                <div className="feature-box-inner flex row align-center gap-20">
                                    <img src={images.general.ft1} alt="" />
                                    <div className="">
                                        <h4 className="md_bold mgb-10">Launchpad-Specific Privacy</h4>
                                        <h5 className="md_regular">Not generic, chain-wide anonymity precision-built for bonding-curve ecosystems.</h5>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-box position-relative" data-aos="fade-up">
                                <div className="ft-effect top-right"></div>
                                <div className="ft-effect bottom-left"></div>
                                <div className="feature-box-inner flex row align-center gap-20">
                                    <img src={images.general.ft2} alt="" />
                                    <div className="">
                                        <h4 className="md_bold mgb-10">Non-Mixer Approach</h4>
                                        <h5 className="md_regular">No cross-chain mixing, no pooled funds, no illegal flows.</h5>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-box position-relative" data-aos="fade-up">
                                <div className="ft-effect top-right"></div>
                                <div className="ft-effect bottom-left"></div>
                                <div className="feature-box-inner flex row align-center gap-20">
                                    <img src={images.general.ft3} alt="" />
                                    <div className="">
                                        <h4 className="md_bold mgb-10">Behavioral Obfuscation</h4>
                                        <h5 className="md_regular">Not only unlinkability but execution noise and timing distortion.</h5>
                                    </div>
                                </div>
                            </div>

                            {windowWidth < 700 && <div className="feature-box position-relative">
                                <div className="ft-effect top-right"></div>
                                <div className="ft-effect bottom-left"></div>
                                <div className="feature-box-inner flex row align-center gap-20">
                                    <img src={images.general.ft4} alt="" />
                                    <div className="">
                                        <h4 className="md_bold mgb-10">Dev-Ready API</h4>
                                        <h5 className="md_regular">Bots, launchpad tools, creator dashboards can plug directly into Evalys.</h5>
                                    </div>
                                </div>
                            </div>}
                            {windowWidth > 800 && <div className="feature-box position-relative" data-aos="fade-left">
                                <div className="ft-effect top-right"></div>
                                <div className="ft-effect bottom-left"></div>
                                <div className="feature-box-inner flex row align-center gap-20">
                                    <img src={images.general.ft4} alt="" />
                                    <div className="">
                                        <h4 className="md_bold mgb-10">Dev-Ready API</h4>
                                        <h5 className="md_regular">Bots, launchpad tools, creator dashboards can plug directly into Evalys.</h5>
                                    </div>
                                </div>
                            </div>}

                        </div>
                    </div>
                </div>
            </section>
            

            

            

        </div>

        
            


    );
}
 
export default Home;